var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiagram = function SvgDiagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "currentColor",
    viewBox: "0 0 20 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.666a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m-4.167 2.5a4.167 4.167 0 1 1 5 4.084v2.583h3.334a2.5 2.5 0 0 1 2.5 2.5v1.75a4.167 4.167 0 1 1-1.667 0v-1.75a.833.833 0 0 0-.833-.833H5.833a.833.833 0 0 0-.833.834v1.75a4.167 4.167 0 1 1-1.667 0v-1.75a2.5 2.5 0 0 1 2.5-2.5h3.334V8.25a4.17 4.17 0 0 1-3.334-4.084M4.167 16.667a2.5 2.5 0 1 0 0 5.001 2.5 2.5 0 0 0 0-5.001m11.666 0a2.5 2.5 0 1 0 0 5.001 2.5 2.5 0 0 0 0-5.001"
  })));
};
export default SvgDiagram;